/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NativeApplicationRouteImport } from './routes/native-application'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as DebugNativeApplicationRouteImport } from './routes/debug/native-application'
import { Route as AuthenticatedManagementRouteRouteImport } from './routes/_authenticated/management/route'
import { Route as AuthenticatedManagementSystemDashboardRouteImport } from './routes/_authenticated/management/system-dashboard'
import { Route as AuthenticatedManagementResidentDataExporterRouteImport } from './routes/_authenticated/management/resident-data-exporter'
import { Route as AuthenticatedFacilitiesFacilityKeyRouteRouteImport } from './routes/_authenticated/facilities/$facilityKey/route'
import { Route as AuthenticatedManagementWatchtowersIndexRouteImport } from './routes/_authenticated/management/watchtowers/index'
import { Route as AuthenticatedManagementUtilitiesIndexRouteImport } from './routes/_authenticated/management/utilities/index'
import { Route as AuthenticatedManagementProvidersIndexRouteImport } from './routes/_authenticated/management/providers/index'
import { Route as AuthenticatedManagementOrganizationsIndexRouteImport } from './routes/_authenticated/management/organizations/index'
import { Route as AuthenticatedManagementFacilitiesIndexRouteImport } from './routes/_authenticated/management/facilities/index'
import { Route as AuthenticatedFacilitiesFacilityKeyIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/index'
import { Route as AuthenticatedManagementWatchtowersRegistrationRouteImport } from './routes/_authenticated/management/watchtowers/registration'
import { Route as AuthenticatedManagementProvidersRegistrationRouteImport } from './routes/_authenticated/management/providers/registration'
import { Route as AuthenticatedManagementOrganizationsRegistrationRouteImport } from './routes/_authenticated/management/organizations/registration'
import { Route as AuthenticatedManagementFacilitiesRegistrationRouteImport } from './routes/_authenticated/management/facilities/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/text-to-speech/index'
import { Route as AuthenticatedFacilitiesFacilityKeyStaffsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/staffs/index'
import { Route as AuthenticatedFacilitiesFacilityKeySensorsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/sensors/index'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/index'
import { Route as AuthenticatedFacilitiesFacilityKeyGroupsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/groups/index'
import { Route as AuthenticatedFacilitiesFacilityKeyBedsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/beds/index'
import { Route as AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/staffs/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRouteImport } from './routes/_authenticated/facilities/$facilityKey/staffs/$userKey'
import { Route as AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/simple-independence-levels/registration'
import { Route as AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/simple-independence-levels/batch-registration'
import { Route as AuthenticatedFacilitiesFacilityKeySensorsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/sensors/registration'
import { Route as AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/sensors/batch-registration'
import { Route as AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRouteImport } from './routes/_authenticated/facilities/$facilityKey/sensors/$sensorKey'
import { Route as AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/rooms/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/rooms/batch-registration'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/batch-registration'
import { Route as AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/groups/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteImport } from './routes/_authenticated/facilities/$facilityKey/groups/$groupKey'
import { Route as AuthenticatedFacilitiesFacilityKeyBedsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/beds/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/beds/batch-registration'
import { Route as AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRouteImport } from './routes/_authenticated/facilities/$facilityKey/beds/batch-allocation'
import { Route as AuthenticatedFacilitiesFacilityKeyBedsAllocationRouteImport } from './routes/_authenticated/facilities/$facilityKey/beds/allocation'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/route'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/index'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/states'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/modification'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/fall-risks'
import { Route as AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRouteImport } from './routes/_authenticated/facilities/$facilityKey/groups/$groupKey.modification'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/falls/index'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/falls/registration'
import { Route as AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRouteImport } from './routes/_authenticated/facilities/$facilityKey/residents/$userKey/assessments.registration'

const NativeApplicationRoute = NativeApplicationRouteImport.update({
  id: '/native-application',
  path: '/native-application',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugNativeApplicationRoute = DebugNativeApplicationRouteImport.update({
  id: '/debug/native-application',
  path: '/debug/native-application',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedManagementRouteRoute =
  AuthenticatedManagementRouteRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManagementSystemDashboardRoute =
  AuthenticatedManagementSystemDashboardRouteImport.update({
    id: '/system-dashboard',
    path: '/system-dashboard',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementResidentDataExporterRoute =
  AuthenticatedManagementResidentDataExporterRouteImport.update({
    id: '/resident-data-exporter',
    path: '/resident-data-exporter',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyRouteRoute =
  AuthenticatedFacilitiesFacilityKeyRouteRouteImport.update({
    id: '/facilities/$facilityKey',
    path: '/facilities/$facilityKey',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManagementWatchtowersIndexRoute =
  AuthenticatedManagementWatchtowersIndexRouteImport.update({
    id: '/watchtowers/',
    path: '/watchtowers/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementUtilitiesIndexRoute =
  AuthenticatedManagementUtilitiesIndexRouteImport.update({
    id: '/utilities/',
    path: '/utilities/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementProvidersIndexRoute =
  AuthenticatedManagementProvidersIndexRouteImport.update({
    id: '/providers/',
    path: '/providers/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementOrganizationsIndexRoute =
  AuthenticatedManagementOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementFacilitiesIndexRoute =
  AuthenticatedManagementFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyIndexRoute =
  AuthenticatedFacilitiesFacilityKeyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedManagementWatchtowersRegistrationRoute =
  AuthenticatedManagementWatchtowersRegistrationRouteImport.update({
    id: '/watchtowers/registration',
    path: '/watchtowers/registration',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementProvidersRegistrationRoute =
  AuthenticatedManagementProvidersRegistrationRouteImport.update({
    id: '/providers/registration',
    path: '/providers/registration',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementOrganizationsRegistrationRoute =
  AuthenticatedManagementOrganizationsRegistrationRouteImport.update({
    id: '/organizations/registration',
    path: '/organizations/registration',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedManagementFacilitiesRegistrationRoute =
  AuthenticatedManagementFacilitiesRegistrationRouteImport.update({
    id: '/facilities/registration',
    path: '/facilities/registration',
    getParentRoute: () => AuthenticatedManagementRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute =
  AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRouteImport.update({
    id: '/text-to-speech/',
    path: '/text-to-speech/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute =
  AuthenticatedFacilitiesFacilityKeyStaffsIndexRouteImport.update({
    id: '/staffs/',
    path: '/staffs/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeySensorsIndexRoute =
  AuthenticatedFacilitiesFacilityKeySensorsIndexRouteImport.update({
    id: '/sensors/',
    path: '/sensors/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsIndexRouteImport.update({
    id: '/residents/',
    path: '/residents/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute =
  AuthenticatedFacilitiesFacilityKeyGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyBedsIndexRoute =
  AuthenticatedFacilitiesFacilityKeyBedsIndexRouteImport.update({
    id: '/beds/',
    path: '/beds/',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRouteImport.update({
    id: '/staffs/registration',
    path: '/staffs/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute =
  AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRouteImport.update({
    id: '/staffs/$userKey',
    path: '/staffs/$userKey',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRouteImport.update(
    {
      id: '/simple-independence-levels/registration',
      path: '/simple-independence-levels/registration',
      getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRouteImport.update(
    {
      id: '/simple-independence-levels/batch-registration',
      path: '/simple-independence-levels/batch-registration',
      getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeySensorsRegistrationRouteImport.update({
    id: '/sensors/registration',
    path: '/sensors/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRouteImport.update({
    id: '/sensors/batch-registration',
    path: '/sensors/batch-registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute =
  AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRouteImport.update({
    id: '/sensors/$sensorKey',
    path: '/sensors/$sensorKey',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRouteImport.update({
    id: '/rooms/registration',
    path: '/rooms/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRouteImport.update({
    id: '/rooms/batch-registration',
    path: '/rooms/batch-registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRouteImport.update({
    id: '/residents/registration',
    path: '/residents/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRouteImport.update(
    {
      id: '/residents/batch-registration',
      path: '/residents/batch-registration',
      getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRouteImport.update({
    id: '/groups/registration',
    path: '/groups/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute =
  AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteImport.update({
    id: '/groups/$groupKey',
    path: '/groups/$groupKey',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyBedsRegistrationRouteImport.update({
    id: '/beds/registration',
    path: '/beds/registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRouteImport.update({
    id: '/beds/batch-registration',
    path: '/beds/batch-registration',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute =
  AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRouteImport.update({
    id: '/beds/batch-allocation',
    path: '/beds/batch-allocation',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute =
  AuthenticatedFacilitiesFacilityKeyBedsAllocationRouteImport.update({
    id: '/beds/allocation',
    path: '/beds/allocation',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteImport.update({
    id: '/residents/$userKey',
    path: '/residents/$userKey',
    getParentRoute: () => AuthenticatedFacilitiesFacilityKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRouteImport.update({
    id: '/states',
    path: '/states',
    getParentRoute: () =>
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
  } as any)
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRouteImport.update(
    {
      id: '/modification',
      path: '/modification',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRouteImport.update(
    {
      id: '/fall-risks',
      path: '/fall-risks',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute =
  AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRouteImport.update(
    {
      id: '/modification',
      path: '/modification',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRouteImport.update(
    {
      id: '/falls/',
      path: '/falls/',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRouteImport.update(
    {
      id: '/independence-levels/registration',
      path: '/independence-levels/registration',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRouteImport.update(
    {
      id: '/independence-levels/$fimItem',
      path: '/independence-levels/$fimItem',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRouteImport.update(
    {
      id: '/falls/registration',
      path: '/falls/registration',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )
const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRouteImport.update(
    {
      id: '/assessments/registration',
      path: '/assessments/registration',
      getParentRoute: () =>
        AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/native-application': typeof NativeApplicationRoute
  '/management': typeof AuthenticatedManagementRouteRouteWithChildren
  '/debug/native-application': typeof DebugNativeApplicationRoute
  '/facilities/$facilityKey': typeof AuthenticatedFacilitiesFacilityKeyRouteRouteWithChildren
  '/management/resident-data-exporter': typeof AuthenticatedManagementResidentDataExporterRoute
  '/management/system-dashboard': typeof AuthenticatedManagementSystemDashboardRoute
  '/management/facilities/registration': typeof AuthenticatedManagementFacilitiesRegistrationRoute
  '/management/organizations/registration': typeof AuthenticatedManagementOrganizationsRegistrationRoute
  '/management/providers/registration': typeof AuthenticatedManagementProvidersRegistrationRoute
  '/management/watchtowers/registration': typeof AuthenticatedManagementWatchtowersRegistrationRoute
  '/facilities/$facilityKey/': typeof AuthenticatedFacilitiesFacilityKeyIndexRoute
  '/management/facilities/': typeof AuthenticatedManagementFacilitiesIndexRoute
  '/management/organizations/': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/management/providers/': typeof AuthenticatedManagementProvidersIndexRoute
  '/management/utilities/': typeof AuthenticatedManagementUtilitiesIndexRoute
  '/management/watchtowers/': typeof AuthenticatedManagementWatchtowersIndexRoute
  '/facilities/$facilityKey/residents/$userKey': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteWithChildren
  '/facilities/$facilityKey/beds/allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute
  '/facilities/$facilityKey/beds/batch-allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute
  '/facilities/$facilityKey/beds/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute
  '/facilities/$facilityKey/beds/registration': typeof AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute
  '/facilities/$facilityKey/groups/$groupKey': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren
  '/facilities/$facilityKey/groups/registration': typeof AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute
  '/facilities/$facilityKey/residents/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute
  '/facilities/$facilityKey/residents/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute
  '/facilities/$facilityKey/rooms/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute
  '/facilities/$facilityKey/rooms/registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute
  '/facilities/$facilityKey/sensors/$sensorKey': typeof AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute
  '/facilities/$facilityKey/sensors/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute
  '/facilities/$facilityKey/sensors/registration': typeof AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute
  '/facilities/$facilityKey/simple-independence-levels/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute
  '/facilities/$facilityKey/simple-independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute
  '/facilities/$facilityKey/staffs/$userKey': typeof AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute
  '/facilities/$facilityKey/staffs/registration': typeof AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute
  '/facilities/$facilityKey/beds/': typeof AuthenticatedFacilitiesFacilityKeyBedsIndexRoute
  '/facilities/$facilityKey/groups/': typeof AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute
  '/facilities/$facilityKey/residents/': typeof AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute
  '/facilities/$facilityKey/sensors/': typeof AuthenticatedFacilitiesFacilityKeySensorsIndexRoute
  '/facilities/$facilityKey/staffs/': typeof AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute
  '/facilities/$facilityKey/text-to-speech/': typeof AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute
  '/facilities/$facilityKey/groups/$groupKey/modification': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute
  '/facilities/$facilityKey/residents/$userKey/fall-risks': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute
  '/facilities/$facilityKey/residents/$userKey/modification': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute
  '/facilities/$facilityKey/residents/$userKey/states': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute
  '/facilities/$facilityKey/residents/$userKey/': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute
  '/facilities/$facilityKey/residents/$userKey/assessments/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/falls/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute
  '/facilities/$facilityKey/residents/$userKey/independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/falls/': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/native-application': typeof NativeApplicationRoute
  '/management': typeof AuthenticatedManagementRouteRouteWithChildren
  '/debug/native-application': typeof DebugNativeApplicationRoute
  '/management/resident-data-exporter': typeof AuthenticatedManagementResidentDataExporterRoute
  '/management/system-dashboard': typeof AuthenticatedManagementSystemDashboardRoute
  '/management/facilities/registration': typeof AuthenticatedManagementFacilitiesRegistrationRoute
  '/management/organizations/registration': typeof AuthenticatedManagementOrganizationsRegistrationRoute
  '/management/providers/registration': typeof AuthenticatedManagementProvidersRegistrationRoute
  '/management/watchtowers/registration': typeof AuthenticatedManagementWatchtowersRegistrationRoute
  '/facilities/$facilityKey': typeof AuthenticatedFacilitiesFacilityKeyIndexRoute
  '/management/facilities': typeof AuthenticatedManagementFacilitiesIndexRoute
  '/management/organizations': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/management/providers': typeof AuthenticatedManagementProvidersIndexRoute
  '/management/utilities': typeof AuthenticatedManagementUtilitiesIndexRoute
  '/management/watchtowers': typeof AuthenticatedManagementWatchtowersIndexRoute
  '/facilities/$facilityKey/beds/allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute
  '/facilities/$facilityKey/beds/batch-allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute
  '/facilities/$facilityKey/beds/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute
  '/facilities/$facilityKey/beds/registration': typeof AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute
  '/facilities/$facilityKey/groups/$groupKey': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren
  '/facilities/$facilityKey/groups/registration': typeof AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute
  '/facilities/$facilityKey/residents/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute
  '/facilities/$facilityKey/residents/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute
  '/facilities/$facilityKey/rooms/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute
  '/facilities/$facilityKey/rooms/registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute
  '/facilities/$facilityKey/sensors/$sensorKey': typeof AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute
  '/facilities/$facilityKey/sensors/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute
  '/facilities/$facilityKey/sensors/registration': typeof AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute
  '/facilities/$facilityKey/simple-independence-levels/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute
  '/facilities/$facilityKey/simple-independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute
  '/facilities/$facilityKey/staffs/$userKey': typeof AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute
  '/facilities/$facilityKey/staffs/registration': typeof AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute
  '/facilities/$facilityKey/beds': typeof AuthenticatedFacilitiesFacilityKeyBedsIndexRoute
  '/facilities/$facilityKey/groups': typeof AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute
  '/facilities/$facilityKey/residents': typeof AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute
  '/facilities/$facilityKey/sensors': typeof AuthenticatedFacilitiesFacilityKeySensorsIndexRoute
  '/facilities/$facilityKey/staffs': typeof AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute
  '/facilities/$facilityKey/text-to-speech': typeof AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute
  '/facilities/$facilityKey/groups/$groupKey/modification': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute
  '/facilities/$facilityKey/residents/$userKey/fall-risks': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute
  '/facilities/$facilityKey/residents/$userKey/modification': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute
  '/facilities/$facilityKey/residents/$userKey/states': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute
  '/facilities/$facilityKey/residents/$userKey': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute
  '/facilities/$facilityKey/residents/$userKey/assessments/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/falls/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute
  '/facilities/$facilityKey/residents/$userKey/independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute
  '/facilities/$facilityKey/residents/$userKey/falls': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/native-application': typeof NativeApplicationRoute
  '/_authenticated/management': typeof AuthenticatedManagementRouteRouteWithChildren
  '/debug/native-application': typeof DebugNativeApplicationRoute
  '/_authenticated/facilities/$facilityKey': typeof AuthenticatedFacilitiesFacilityKeyRouteRouteWithChildren
  '/_authenticated/management/resident-data-exporter': typeof AuthenticatedManagementResidentDataExporterRoute
  '/_authenticated/management/system-dashboard': typeof AuthenticatedManagementSystemDashboardRoute
  '/_authenticated/management/facilities/registration': typeof AuthenticatedManagementFacilitiesRegistrationRoute
  '/_authenticated/management/organizations/registration': typeof AuthenticatedManagementOrganizationsRegistrationRoute
  '/_authenticated/management/providers/registration': typeof AuthenticatedManagementProvidersRegistrationRoute
  '/_authenticated/management/watchtowers/registration': typeof AuthenticatedManagementWatchtowersRegistrationRoute
  '/_authenticated/facilities/$facilityKey/': typeof AuthenticatedFacilitiesFacilityKeyIndexRoute
  '/_authenticated/management/facilities/': typeof AuthenticatedManagementFacilitiesIndexRoute
  '/_authenticated/management/organizations/': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/_authenticated/management/providers/': typeof AuthenticatedManagementProvidersIndexRoute
  '/_authenticated/management/utilities/': typeof AuthenticatedManagementUtilitiesIndexRoute
  '/_authenticated/management/watchtowers/': typeof AuthenticatedManagementWatchtowersIndexRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteWithChildren
  '/_authenticated/facilities/$facilityKey/beds/allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute
  '/_authenticated/facilities/$facilityKey/beds/batch-allocation': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute
  '/_authenticated/facilities/$facilityKey/beds/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute
  '/_authenticated/facilities/$facilityKey/beds/registration': typeof AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/groups/$groupKey': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren
  '/_authenticated/facilities/$facilityKey/groups/registration': typeof AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/residents/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute
  '/_authenticated/facilities/$facilityKey/residents/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/rooms/batch-registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute
  '/_authenticated/facilities/$facilityKey/rooms/registration': typeof AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/sensors/$sensorKey': typeof AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute
  '/_authenticated/facilities/$facilityKey/sensors/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute
  '/_authenticated/facilities/$facilityKey/sensors/registration': typeof AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/simple-independence-levels/batch-registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute
  '/_authenticated/facilities/$facilityKey/simple-independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/staffs/$userKey': typeof AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute
  '/_authenticated/facilities/$facilityKey/staffs/registration': typeof AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/beds/': typeof AuthenticatedFacilitiesFacilityKeyBedsIndexRoute
  '/_authenticated/facilities/$facilityKey/groups/': typeof AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute
  '/_authenticated/facilities/$facilityKey/residents/': typeof AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute
  '/_authenticated/facilities/$facilityKey/sensors/': typeof AuthenticatedFacilitiesFacilityKeySensorsIndexRoute
  '/_authenticated/facilities/$facilityKey/staffs/': typeof AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute
  '/_authenticated/facilities/$facilityKey/text-to-speech/': typeof AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute
  '/_authenticated/facilities/$facilityKey/groups/$groupKey/modification': typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/fall-risks': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/modification': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/states': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/assessments/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/registration': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute
  '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/': typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/native-application'
    | '/management'
    | '/debug/native-application'
    | '/facilities/$facilityKey'
    | '/management/resident-data-exporter'
    | '/management/system-dashboard'
    | '/management/facilities/registration'
    | '/management/organizations/registration'
    | '/management/providers/registration'
    | '/management/watchtowers/registration'
    | '/facilities/$facilityKey/'
    | '/management/facilities/'
    | '/management/organizations/'
    | '/management/providers/'
    | '/management/utilities/'
    | '/management/watchtowers/'
    | '/facilities/$facilityKey/residents/$userKey'
    | '/facilities/$facilityKey/beds/allocation'
    | '/facilities/$facilityKey/beds/batch-allocation'
    | '/facilities/$facilityKey/beds/batch-registration'
    | '/facilities/$facilityKey/beds/registration'
    | '/facilities/$facilityKey/groups/$groupKey'
    | '/facilities/$facilityKey/groups/registration'
    | '/facilities/$facilityKey/residents/batch-registration'
    | '/facilities/$facilityKey/residents/registration'
    | '/facilities/$facilityKey/rooms/batch-registration'
    | '/facilities/$facilityKey/rooms/registration'
    | '/facilities/$facilityKey/sensors/$sensorKey'
    | '/facilities/$facilityKey/sensors/batch-registration'
    | '/facilities/$facilityKey/sensors/registration'
    | '/facilities/$facilityKey/simple-independence-levels/batch-registration'
    | '/facilities/$facilityKey/simple-independence-levels/registration'
    | '/facilities/$facilityKey/staffs/$userKey'
    | '/facilities/$facilityKey/staffs/registration'
    | '/facilities/$facilityKey/beds/'
    | '/facilities/$facilityKey/groups/'
    | '/facilities/$facilityKey/residents/'
    | '/facilities/$facilityKey/sensors/'
    | '/facilities/$facilityKey/staffs/'
    | '/facilities/$facilityKey/text-to-speech/'
    | '/facilities/$facilityKey/groups/$groupKey/modification'
    | '/facilities/$facilityKey/residents/$userKey/fall-risks'
    | '/facilities/$facilityKey/residents/$userKey/modification'
    | '/facilities/$facilityKey/residents/$userKey/states'
    | '/facilities/$facilityKey/residents/$userKey/'
    | '/facilities/$facilityKey/residents/$userKey/assessments/registration'
    | '/facilities/$facilityKey/residents/$userKey/falls/registration'
    | '/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
    | '/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
    | '/facilities/$facilityKey/residents/$userKey/falls/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/native-application'
    | '/management'
    | '/debug/native-application'
    | '/management/resident-data-exporter'
    | '/management/system-dashboard'
    | '/management/facilities/registration'
    | '/management/organizations/registration'
    | '/management/providers/registration'
    | '/management/watchtowers/registration'
    | '/facilities/$facilityKey'
    | '/management/facilities'
    | '/management/organizations'
    | '/management/providers'
    | '/management/utilities'
    | '/management/watchtowers'
    | '/facilities/$facilityKey/beds/allocation'
    | '/facilities/$facilityKey/beds/batch-allocation'
    | '/facilities/$facilityKey/beds/batch-registration'
    | '/facilities/$facilityKey/beds/registration'
    | '/facilities/$facilityKey/groups/$groupKey'
    | '/facilities/$facilityKey/groups/registration'
    | '/facilities/$facilityKey/residents/batch-registration'
    | '/facilities/$facilityKey/residents/registration'
    | '/facilities/$facilityKey/rooms/batch-registration'
    | '/facilities/$facilityKey/rooms/registration'
    | '/facilities/$facilityKey/sensors/$sensorKey'
    | '/facilities/$facilityKey/sensors/batch-registration'
    | '/facilities/$facilityKey/sensors/registration'
    | '/facilities/$facilityKey/simple-independence-levels/batch-registration'
    | '/facilities/$facilityKey/simple-independence-levels/registration'
    | '/facilities/$facilityKey/staffs/$userKey'
    | '/facilities/$facilityKey/staffs/registration'
    | '/facilities/$facilityKey/beds'
    | '/facilities/$facilityKey/groups'
    | '/facilities/$facilityKey/residents'
    | '/facilities/$facilityKey/sensors'
    | '/facilities/$facilityKey/staffs'
    | '/facilities/$facilityKey/text-to-speech'
    | '/facilities/$facilityKey/groups/$groupKey/modification'
    | '/facilities/$facilityKey/residents/$userKey/fall-risks'
    | '/facilities/$facilityKey/residents/$userKey/modification'
    | '/facilities/$facilityKey/residents/$userKey/states'
    | '/facilities/$facilityKey/residents/$userKey'
    | '/facilities/$facilityKey/residents/$userKey/assessments/registration'
    | '/facilities/$facilityKey/residents/$userKey/falls/registration'
    | '/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
    | '/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
    | '/facilities/$facilityKey/residents/$userKey/falls'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/native-application'
    | '/_authenticated/management'
    | '/debug/native-application'
    | '/_authenticated/facilities/$facilityKey'
    | '/_authenticated/management/resident-data-exporter'
    | '/_authenticated/management/system-dashboard'
    | '/_authenticated/management/facilities/registration'
    | '/_authenticated/management/organizations/registration'
    | '/_authenticated/management/providers/registration'
    | '/_authenticated/management/watchtowers/registration'
    | '/_authenticated/facilities/$facilityKey/'
    | '/_authenticated/management/facilities/'
    | '/_authenticated/management/organizations/'
    | '/_authenticated/management/providers/'
    | '/_authenticated/management/utilities/'
    | '/_authenticated/management/watchtowers/'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey'
    | '/_authenticated/facilities/$facilityKey/beds/allocation'
    | '/_authenticated/facilities/$facilityKey/beds/batch-allocation'
    | '/_authenticated/facilities/$facilityKey/beds/batch-registration'
    | '/_authenticated/facilities/$facilityKey/beds/registration'
    | '/_authenticated/facilities/$facilityKey/groups/$groupKey'
    | '/_authenticated/facilities/$facilityKey/groups/registration'
    | '/_authenticated/facilities/$facilityKey/residents/batch-registration'
    | '/_authenticated/facilities/$facilityKey/residents/registration'
    | '/_authenticated/facilities/$facilityKey/rooms/batch-registration'
    | '/_authenticated/facilities/$facilityKey/rooms/registration'
    | '/_authenticated/facilities/$facilityKey/sensors/$sensorKey'
    | '/_authenticated/facilities/$facilityKey/sensors/batch-registration'
    | '/_authenticated/facilities/$facilityKey/sensors/registration'
    | '/_authenticated/facilities/$facilityKey/simple-independence-levels/batch-registration'
    | '/_authenticated/facilities/$facilityKey/simple-independence-levels/registration'
    | '/_authenticated/facilities/$facilityKey/staffs/$userKey'
    | '/_authenticated/facilities/$facilityKey/staffs/registration'
    | '/_authenticated/facilities/$facilityKey/beds/'
    | '/_authenticated/facilities/$facilityKey/groups/'
    | '/_authenticated/facilities/$facilityKey/residents/'
    | '/_authenticated/facilities/$facilityKey/sensors/'
    | '/_authenticated/facilities/$facilityKey/staffs/'
    | '/_authenticated/facilities/$facilityKey/text-to-speech/'
    | '/_authenticated/facilities/$facilityKey/groups/$groupKey/modification'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/fall-risks'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/modification'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/states'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/assessments/registration'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/registration'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
    | '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  NativeApplicationRoute: typeof NativeApplicationRoute
  DebugNativeApplicationRoute: typeof DebugNativeApplicationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/native-application': {
      id: '/native-application'
      path: '/native-application'
      fullPath: '/native-application'
      preLoaderRoute: typeof NativeApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/native-application': {
      id: '/debug/native-application'
      path: '/debug/native-application'
      fullPath: '/debug/native-application'
      preLoaderRoute: typeof DebugNativeApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/management': {
      id: '/_authenticated/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof AuthenticatedManagementRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/management/system-dashboard': {
      id: '/_authenticated/management/system-dashboard'
      path: '/system-dashboard'
      fullPath: '/management/system-dashboard'
      preLoaderRoute: typeof AuthenticatedManagementSystemDashboardRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/resident-data-exporter': {
      id: '/_authenticated/management/resident-data-exporter'
      path: '/resident-data-exporter'
      fullPath: '/management/resident-data-exporter'
      preLoaderRoute: typeof AuthenticatedManagementResidentDataExporterRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/facilities/$facilityKey': {
      id: '/_authenticated/facilities/$facilityKey'
      path: '/facilities/$facilityKey'
      fullPath: '/facilities/$facilityKey'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/management/watchtowers/': {
      id: '/_authenticated/management/watchtowers/'
      path: '/watchtowers'
      fullPath: '/management/watchtowers/'
      preLoaderRoute: typeof AuthenticatedManagementWatchtowersIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/utilities/': {
      id: '/_authenticated/management/utilities/'
      path: '/utilities'
      fullPath: '/management/utilities/'
      preLoaderRoute: typeof AuthenticatedManagementUtilitiesIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/providers/': {
      id: '/_authenticated/management/providers/'
      path: '/providers'
      fullPath: '/management/providers/'
      preLoaderRoute: typeof AuthenticatedManagementProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/organizations/': {
      id: '/_authenticated/management/organizations/'
      path: '/organizations'
      fullPath: '/management/organizations/'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/facilities/': {
      id: '/_authenticated/management/facilities/'
      path: '/facilities'
      fullPath: '/management/facilities/'
      preLoaderRoute: typeof AuthenticatedManagementFacilitiesIndexRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/': {
      id: '/_authenticated/facilities/$facilityKey/'
      path: '/'
      fullPath: '/facilities/$facilityKey/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/management/watchtowers/registration': {
      id: '/_authenticated/management/watchtowers/registration'
      path: '/watchtowers/registration'
      fullPath: '/management/watchtowers/registration'
      preLoaderRoute: typeof AuthenticatedManagementWatchtowersRegistrationRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/providers/registration': {
      id: '/_authenticated/management/providers/registration'
      path: '/providers/registration'
      fullPath: '/management/providers/registration'
      preLoaderRoute: typeof AuthenticatedManagementProvidersRegistrationRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/organizations/registration': {
      id: '/_authenticated/management/organizations/registration'
      path: '/organizations/registration'
      fullPath: '/management/organizations/registration'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsRegistrationRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/management/facilities/registration': {
      id: '/_authenticated/management/facilities/registration'
      path: '/facilities/registration'
      fullPath: '/management/facilities/registration'
      preLoaderRoute: typeof AuthenticatedManagementFacilitiesRegistrationRouteImport
      parentRoute: typeof AuthenticatedManagementRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/text-to-speech/': {
      id: '/_authenticated/facilities/$facilityKey/text-to-speech/'
      path: '/text-to-speech'
      fullPath: '/facilities/$facilityKey/text-to-speech/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/staffs/': {
      id: '/_authenticated/facilities/$facilityKey/staffs/'
      path: '/staffs'
      fullPath: '/facilities/$facilityKey/staffs/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/sensors/': {
      id: '/_authenticated/facilities/$facilityKey/sensors/'
      path: '/sensors'
      fullPath: '/facilities/$facilityKey/sensors/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/': {
      id: '/_authenticated/facilities/$facilityKey/residents/'
      path: '/residents'
      fullPath: '/facilities/$facilityKey/residents/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/groups/': {
      id: '/_authenticated/facilities/$facilityKey/groups/'
      path: '/groups'
      fullPath: '/facilities/$facilityKey/groups/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/beds/': {
      id: '/_authenticated/facilities/$facilityKey/beds/'
      path: '/beds'
      fullPath: '/facilities/$facilityKey/beds/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/staffs/registration': {
      id: '/_authenticated/facilities/$facilityKey/staffs/registration'
      path: '/staffs/registration'
      fullPath: '/facilities/$facilityKey/staffs/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/staffs/$userKey': {
      id: '/_authenticated/facilities/$facilityKey/staffs/$userKey'
      path: '/staffs/$userKey'
      fullPath: '/facilities/$facilityKey/staffs/$userKey'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/simple-independence-levels/registration': {
      id: '/_authenticated/facilities/$facilityKey/simple-independence-levels/registration'
      path: '/simple-independence-levels/registration'
      fullPath: '/facilities/$facilityKey/simple-independence-levels/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/simple-independence-levels/batch-registration': {
      id: '/_authenticated/facilities/$facilityKey/simple-independence-levels/batch-registration'
      path: '/simple-independence-levels/batch-registration'
      fullPath: '/facilities/$facilityKey/simple-independence-levels/batch-registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/sensors/registration': {
      id: '/_authenticated/facilities/$facilityKey/sensors/registration'
      path: '/sensors/registration'
      fullPath: '/facilities/$facilityKey/sensors/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/sensors/batch-registration': {
      id: '/_authenticated/facilities/$facilityKey/sensors/batch-registration'
      path: '/sensors/batch-registration'
      fullPath: '/facilities/$facilityKey/sensors/batch-registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/sensors/$sensorKey': {
      id: '/_authenticated/facilities/$facilityKey/sensors/$sensorKey'
      path: '/sensors/$sensorKey'
      fullPath: '/facilities/$facilityKey/sensors/$sensorKey'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/rooms/registration': {
      id: '/_authenticated/facilities/$facilityKey/rooms/registration'
      path: '/rooms/registration'
      fullPath: '/facilities/$facilityKey/rooms/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/rooms/batch-registration': {
      id: '/_authenticated/facilities/$facilityKey/rooms/batch-registration'
      path: '/rooms/batch-registration'
      fullPath: '/facilities/$facilityKey/rooms/batch-registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/registration': {
      id: '/_authenticated/facilities/$facilityKey/residents/registration'
      path: '/residents/registration'
      fullPath: '/facilities/$facilityKey/residents/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/batch-registration': {
      id: '/_authenticated/facilities/$facilityKey/residents/batch-registration'
      path: '/residents/batch-registration'
      fullPath: '/facilities/$facilityKey/residents/batch-registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/groups/registration': {
      id: '/_authenticated/facilities/$facilityKey/groups/registration'
      path: '/groups/registration'
      fullPath: '/facilities/$facilityKey/groups/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/groups/$groupKey': {
      id: '/_authenticated/facilities/$facilityKey/groups/$groupKey'
      path: '/groups/$groupKey'
      fullPath: '/facilities/$facilityKey/groups/$groupKey'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/beds/registration': {
      id: '/_authenticated/facilities/$facilityKey/beds/registration'
      path: '/beds/registration'
      fullPath: '/facilities/$facilityKey/beds/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/beds/batch-registration': {
      id: '/_authenticated/facilities/$facilityKey/beds/batch-registration'
      path: '/beds/batch-registration'
      fullPath: '/facilities/$facilityKey/beds/batch-registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/beds/batch-allocation': {
      id: '/_authenticated/facilities/$facilityKey/beds/batch-allocation'
      path: '/beds/batch-allocation'
      fullPath: '/facilities/$facilityKey/beds/batch-allocation'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/beds/allocation': {
      id: '/_authenticated/facilities/$facilityKey/beds/allocation'
      path: '/beds/allocation'
      fullPath: '/facilities/$facilityKey/beds/allocation'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsAllocationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey'
      path: '/residents/$userKey'
      fullPath: '/facilities/$facilityKey/residents/$userKey'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/'
      path: '/'
      fullPath: '/facilities/$facilityKey/residents/$userKey/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/states': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/states'
      path: '/states'
      fullPath: '/facilities/$facilityKey/residents/$userKey/states'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/modification': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/modification'
      path: '/modification'
      fullPath: '/facilities/$facilityKey/residents/$userKey/modification'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/fall-risks': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/fall-risks'
      path: '/fall-risks'
      fullPath: '/facilities/$facilityKey/residents/$userKey/fall-risks'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/groups/$groupKey/modification': {
      id: '/_authenticated/facilities/$facilityKey/groups/$groupKey/modification'
      path: '/modification'
      fullPath: '/facilities/$facilityKey/groups/$groupKey/modification'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/'
      path: '/falls'
      fullPath: '/facilities/$facilityKey/residents/$userKey/falls/'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/registration': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
      path: '/independence-levels/registration'
      fullPath: '/facilities/$facilityKey/residents/$userKey/independence-levels/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
      path: '/independence-levels/$fimItem'
      fullPath: '/facilities/$facilityKey/residents/$userKey/independence-levels/$fimItem'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/registration': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/falls/registration'
      path: '/falls/registration'
      fullPath: '/facilities/$facilityKey/residents/$userKey/falls/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
    '/_authenticated/facilities/$facilityKey/residents/$userKey/assessments/registration': {
      id: '/_authenticated/facilities/$facilityKey/residents/$userKey/assessments/registration'
      path: '/assessments/registration'
      fullPath: '/facilities/$facilityKey/residents/$userKey/assessments/registration'
      preLoaderRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRouteImport
      parentRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute
    }
  }
}

interface AuthenticatedManagementRouteRouteChildren {
  AuthenticatedManagementResidentDataExporterRoute: typeof AuthenticatedManagementResidentDataExporterRoute
  AuthenticatedManagementSystemDashboardRoute: typeof AuthenticatedManagementSystemDashboardRoute
  AuthenticatedManagementFacilitiesRegistrationRoute: typeof AuthenticatedManagementFacilitiesRegistrationRoute
  AuthenticatedManagementOrganizationsRegistrationRoute: typeof AuthenticatedManagementOrganizationsRegistrationRoute
  AuthenticatedManagementProvidersRegistrationRoute: typeof AuthenticatedManagementProvidersRegistrationRoute
  AuthenticatedManagementWatchtowersRegistrationRoute: typeof AuthenticatedManagementWatchtowersRegistrationRoute
  AuthenticatedManagementFacilitiesIndexRoute: typeof AuthenticatedManagementFacilitiesIndexRoute
  AuthenticatedManagementOrganizationsIndexRoute: typeof AuthenticatedManagementOrganizationsIndexRoute
  AuthenticatedManagementProvidersIndexRoute: typeof AuthenticatedManagementProvidersIndexRoute
  AuthenticatedManagementUtilitiesIndexRoute: typeof AuthenticatedManagementUtilitiesIndexRoute
  AuthenticatedManagementWatchtowersIndexRoute: typeof AuthenticatedManagementWatchtowersIndexRoute
}

const AuthenticatedManagementRouteRouteChildren: AuthenticatedManagementRouteRouteChildren =
  {
    AuthenticatedManagementResidentDataExporterRoute:
      AuthenticatedManagementResidentDataExporterRoute,
    AuthenticatedManagementSystemDashboardRoute:
      AuthenticatedManagementSystemDashboardRoute,
    AuthenticatedManagementFacilitiesRegistrationRoute:
      AuthenticatedManagementFacilitiesRegistrationRoute,
    AuthenticatedManagementOrganizationsRegistrationRoute:
      AuthenticatedManagementOrganizationsRegistrationRoute,
    AuthenticatedManagementProvidersRegistrationRoute:
      AuthenticatedManagementProvidersRegistrationRoute,
    AuthenticatedManagementWatchtowersRegistrationRoute:
      AuthenticatedManagementWatchtowersRegistrationRoute,
    AuthenticatedManagementFacilitiesIndexRoute:
      AuthenticatedManagementFacilitiesIndexRoute,
    AuthenticatedManagementOrganizationsIndexRoute:
      AuthenticatedManagementOrganizationsIndexRoute,
    AuthenticatedManagementProvidersIndexRoute:
      AuthenticatedManagementProvidersIndexRoute,
    AuthenticatedManagementUtilitiesIndexRoute:
      AuthenticatedManagementUtilitiesIndexRoute,
    AuthenticatedManagementWatchtowersIndexRoute:
      AuthenticatedManagementWatchtowersIndexRoute,
  }

const AuthenticatedManagementRouteRouteWithChildren =
  AuthenticatedManagementRouteRoute._addFileChildren(
    AuthenticatedManagementRouteRouteChildren,
  )

interface AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteChildren {
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute
}

const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteChildren: AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteChildren =
  {
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallRisksRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyModificationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyStatesRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndexRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyAssessmentsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsFimItemRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyIndependenceLevelsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyFallsIndexRoute,
  }

const AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteWithChildren =
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute._addFileChildren(
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteChildren,
  )

interface AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteChildren {
  AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute
}

const AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteChildren: AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteChildren =
  {
    AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute:
      AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyModificationRoute,
  }

const AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren =
  AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute._addFileChildren(
    AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteChildren,
  )

interface AuthenticatedFacilitiesFacilityKeyRouteRouteChildren {
  AuthenticatedFacilitiesFacilityKeyIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyIndexRoute
  AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteWithChildren
  AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute
  AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute
  AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren
  AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute
  AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute
  AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute
  AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute
  AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute
  AuthenticatedFacilitiesFacilityKeyBedsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyBedsIndexRoute
  AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute
  AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute
  AuthenticatedFacilitiesFacilityKeySensorsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeySensorsIndexRoute
  AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute
  AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute: typeof AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute
}

const AuthenticatedFacilitiesFacilityKeyRouteRouteChildren: AuthenticatedFacilitiesFacilityKeyRouteRouteChildren =
  {
    AuthenticatedFacilitiesFacilityKeyIndexRoute:
      AuthenticatedFacilitiesFacilityKeyIndexRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsUserKeyRouteRouteWithChildren,
    AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute:
      AuthenticatedFacilitiesFacilityKeyBedsAllocationRoute,
    AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute:
      AuthenticatedFacilitiesFacilityKeyBedsBatchAllocationRoute,
    AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyBedsBatchRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyBedsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRoute:
      AuthenticatedFacilitiesFacilityKeyGroupsGroupKeyRouteWithChildren,
    AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyGroupsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsBatchRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyRoomsBatchRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyRoomsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute:
      AuthenticatedFacilitiesFacilityKeySensorsSensorKeyRoute,
    AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeySensorsBatchRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeySensorsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsBatchRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeySimpleIndependenceLevelsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute:
      AuthenticatedFacilitiesFacilityKeyStaffsUserKeyRoute,
    AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute:
      AuthenticatedFacilitiesFacilityKeyStaffsRegistrationRoute,
    AuthenticatedFacilitiesFacilityKeyBedsIndexRoute:
      AuthenticatedFacilitiesFacilityKeyBedsIndexRoute,
    AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute:
      AuthenticatedFacilitiesFacilityKeyGroupsIndexRoute,
    AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute:
      AuthenticatedFacilitiesFacilityKeyResidentsIndexRoute,
    AuthenticatedFacilitiesFacilityKeySensorsIndexRoute:
      AuthenticatedFacilitiesFacilityKeySensorsIndexRoute,
    AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute:
      AuthenticatedFacilitiesFacilityKeyStaffsIndexRoute,
    AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute:
      AuthenticatedFacilitiesFacilityKeyTextToSpeechIndexRoute,
  }

const AuthenticatedFacilitiesFacilityKeyRouteRouteWithChildren =
  AuthenticatedFacilitiesFacilityKeyRouteRoute._addFileChildren(
    AuthenticatedFacilitiesFacilityKeyRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedManagementRouteRoute: typeof AuthenticatedManagementRouteRouteWithChildren
  AuthenticatedFacilitiesFacilityKeyRouteRoute: typeof AuthenticatedFacilitiesFacilityKeyRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedManagementRouteRoute:
    AuthenticatedManagementRouteRouteWithChildren,
  AuthenticatedFacilitiesFacilityKeyRouteRoute:
    AuthenticatedFacilitiesFacilityKeyRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  NativeApplicationRoute: NativeApplicationRoute,
  DebugNativeApplicationRoute: DebugNativeApplicationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
